"use client";

import { useSyncExternalStore } from "react";
import {
  getSignInUiServerSnapshot,
  getSignInUiSnapshot,
  subscribeSignInUi,
  type SignInUiState,
} from "@/lib/auth/sign-in-pending";

export function useSignInUiState(): SignInUiState {
  return useSyncExternalStore(
    subscribeSignInUi,
    getSignInUiSnapshot,
    getSignInUiServerSnapshot,
  );
}
